module.exports = __webpack_public_path__ + "afdbea340ef317ca729f3cfec9b03b91.gif";